import { GetClassGrade } from '@src/services/classgrade'
import { GetLessonsMap } from '@src/services/occupancy-map'
import { GetStudentAttendance, PostAttendance } from '@src/services/attendance'
import { getSavedState } from '@src/utils/localStorage'
import Vue from 'vue'

export const state = {
    classgrade: {},
    lessonsList: [],
    attendanceStudentsList: [],
}

export const getters = {}

export const mutations = {
    SET_CLASS(state, newclass) {
        state.classgrade = newclass
    },
    SET_LESSON_CLASS(state, lesson) {
        state.lessonsList = lesson
    },
    SET_STUDENTS(state, newList) {
        state.attendanceStudentsList = newList
    },
    SET_ATTENDANCE(state, student) {
        state.attendanceStudentsList[student.indexStudent].attendance =
            student.attendance
    },
    UPDATE_LIST(state, newList) {
        Vue.set(state, 'attendanceStudentsList', [...newList])
    },
    SET_STUDENTS_ATTENDANCES(state, attendances) {
        state.attendanceStudentsList.forEach((student) => {
            attendances.forEach((att) => {
                if (att.studentPublicId === student.publicId) {
                    student.attendance = att.attended ? 'yes' : 'no'
                }
            })
        })
    },
}

export const actions = {
    async getClassInfo({ commit, dispatch }, lessonClass) {
        const { classgrade, date } = lessonClass
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetClassGrade(classgrade, locationPublicId)
        const respLesson = await GetLessonsMap({ classgrade, date })
        if (resp.status === 200) {
            commit('SET_CLASS', resp.data.data)
            dispatch('getStudentsAttendance', {
                students: resp.data.data.classStudents,
                classInfo: lessonClass,
            })
        }
        if (respLesson.status === 200) {
            // (respLesson)
            commit('SET_LESSON_CLASS', respLesson.data.data)
        }
    },
    async getStudentsAttendance({ commit }, lessonInfo) {
        const { students, classInfo } = lessonInfo
        const resp = await GetStudentAttendance(classInfo)
        if (!resp.data.data) return commit('SET_STUDENTS', students)
        const attendances = resp.data.data.students
        // include attendances on students
        students.forEach((student) => {
            attendances.forEach((att) => {
                if (att.studentPublicId === student.publicId) {
                    student.attendance = att.attended
                        ? 'yes'
                        : att.attended === false
                        ? 'no'
                        : 'replace'
                }
            })
        })
        commit('SET_STUDENTS', students)
    },
    sendAttendance({ commit, state, dispatch }, student) {
        const { attendance, studentId } = student
        const indexStudent = state.attendanceStudentsList.findIndex(
            ({ publicId }) => publicId === studentId
        )
        commit('SET_ATTENDANCE', {
            indexStudent,
            attendance,
        })
        dispatch('updateStudentsList')
    },
    async setAttendance({ _ }, attendance) {
        attendance.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await PostAttendance(attendance)
        return resp
    },
    updateStudentsList({ commit, state }) {
        commit('UPDATE_LIST', state.attendanceStudentsList)
    },
}
